export default "__VITE_ASSET__ab02fa7a__"